import { Controller, useFormContext } from 'react-hook-form';

import { TextInput } from 'components/DesignSystem/TextInput';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

export const OpcPassword = () => {
    const methods = useFormContext<FormProps>();
    return (
        <Controller
            render={({ field }) => <TextInput {...field} label={'OPC Password'} />}
            name={`opcPassword`}
            control={methods.control}
        />
    );
};
